module.exports = __webpack_public_path__ + "static/media/rw.4b907d3d.jpeg";